export default function TableFooter({
  pagination,
  currentPage,
  setCurrentPage,
}) {
  const {
    count = 0,
    total_pages = 0,
    next,
    previous,
  } = pagination || {};

  const pageSize = 20;

  // Showing entries
  const startIndex =
    count === 0
      ? 0
      : (currentPage - 1) * pageSize + 1;

  const endIndex =
    count === 0
      ? 0
      : Math.min(currentPage * pageSize, count);

  // Previous disabled
  const isPreviousDisabled =
    currentPage <= 1 || previous === 0;

  // Next disabled
  const isNextDisabled =
    currentPage >= total_pages ||
    endIndex >= count;

  // Generate visible pages
  const getVisiblePages = () => {
    if (total_pages <= 5) {
      return Array.from(
        { length: total_pages },
        (_, i) => i + 1
      );
    }

    if (currentPage <= 3) {
      return [1, 2, 3, 4, "...", total_pages];
    }

    if (currentPage >= total_pages - 2) {
      return [
        1,
        "...",
        total_pages - 3,
        total_pages - 2,
        total_pages - 1,
        total_pages,
      ];
    }

    return [
      1,
      "...",
      currentPage - 1,
      currentPage,
      currentPage + 1,
      "...",
      total_pages,
    ];
  };

  const pages = getVisiblePages();

  return (
    <div className="table_footer">

      {/* Showing Entries */}
      <span className="showing-value">
        Showing {startIndex} to {endIndex} of {count} entries
      </span>

      <div className="table_page_action">
        <div className="table-pagination">

          <nav aria-label="Page navigation">
            <ul className="pagination justify-content-end mb-0 gap-2">

              {/* =========================
                  PREVIOUS
              ========================== */}
              <li
                className={`page-item prev-page ${
                  isPreviousDisabled ? "disabled" : ""
                }`}
              >
                <button
                  type="button"
                  className={`page-link ${
                    isPreviousDisabled
                      ? "pagination-disabled"
                      : ""
                  }`}
                  disabled={isPreviousDisabled}
                  onClick={() => {
                    if (!isPreviousDisabled) {
                      setCurrentPage(currentPage - 1);
                    }
                  }}
                >
                  Prev
                </button>
              </li>

              {/* =========================
                  PAGE NUMBERS
              ========================== */}
              {pages.map((page, idx) =>
                page === "..." ? (
                  <li
                    key={`ellipsis-${idx}`}
                    className="page-item disabled"
                  >
                    <span className="page-link pagination-ellipsis">
                      ...
                    </span>
                  </li>
                ) : (
                  <li
                    key={page}
                    className={`page-item ${
                      page === currentPage ? "active" : ""
                    }`}
                  >
                    <button
                      type="button"
                      className="page-link"
                      onClick={() => setCurrentPage(page)}
                    >
                      {page}
                    </button>
                  </li>
                )
              )}

              {/* =========================
                  NEXT
              ========================== */}
              <li
                className={`page-item next-page ${
                  isNextDisabled ? "disabled" : ""
                }`}
              >
                <button
                  type="button"
                  className={`page-link ${
                    isNextDisabled
                      ? "pagination-disabled"
                      : ""
                  }`}
                  disabled={isNextDisabled}
                  onClick={() => {
                    if (!isNextDisabled) {
                      setCurrentPage(currentPage + 1);
                    }
                  }}
                >
                  Next
                </button>
              </li>

            </ul>
          </nav>

        </div>
      </div>
    </div>
  );
}